/******************************************************************
 * Archivo : client/src/queries/fetchViewerUser.js
 * Proyecto: CB30
 *
 * Consulta GraphQL - Visor Universal
 * Obtiene los datos del informante seleccionado.
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  query ViewerUserQuery($id: ID!) {

    viewerUser(id: $id) {

      id
      nombre
      apellido
      email

      person {
        tipo_de_documento
        documento_de_identidad
        lugar_de_expedicion
        fecha_de_nacimiento
        lugar_de_nacimiento
        pais_de_nacimiento
        genero
        raza
        grupo_etnico
        estado_civil
        nivel_educativo
        ocupacion
        direccion
        estrato
        localidad
        departamento
        ciudad
        pais_de_residencia
        telefono
        celular
      }

    }

  }
`;


// WEBPACK FOOTER //
// ./src/queries/fetchViewerUser.js